export default __webpack_public_path__ + "static/media/before.26aefe95.png";